import { cva, type VariantProps } from 'class-variance-authority';
import { BarChart3, List } from 'lucide-react';

const toggleButtonVariants = cva(
  `flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors`,
  {
    variants: {
      active: {
        true: 'bg-action-primary text-text-inverse',
        false: `
          text-text-muted
          hover:text-text-primary
        `,
      },
    },
    defaultVariants: {
      active: false,
    },
  },
);

export type ViewMode = 'timeline' | 'cards';

export interface ViewModeToggleProps extends VariantProps<typeof toggleButtonVariants> {
  /** Currently selected view mode */
  value: ViewMode;
  /** Callback when selection changes */
  onChange: (mode: ViewMode) => void;
  /** Optional additional className */
  className?: string;
}

/**
 * View mode toggle molecule - toggle between timeline and cards views
 *
 * Provides a button group for switching between different view modes
 * in the results visualization. Uses CVA for consistent styling.
 */
export function ViewModeToggle({ value, onChange, className = '' }: ViewModeToggleProps) {
  return (
    <div
      className={`
        flex items-center gap-2 rounded-lg bg-bg-muted p-1
        ${className}
      `}
    >
      <button onClick={() => onChange('timeline')} className={toggleButtonVariants({ active: value === 'timeline' })}>
        <BarChart3 className="size-4" />
        Timeline
      </button>
      <button onClick={() => onChange('cards')} className={toggleButtonVariants({ active: value === 'cards' })}>
        <List className="size-4" />
        Details
      </button>
    </div>
  );
}
